/*
 * Product v2 — keep one gallery thumbnail marked as the selected one.
 *
 * product-thumbnails.js only adds `.is-initial-selected` once the slider
 * changes, so on first load no thumbnail is marked and the "dim the others"
 * styling has nothing to key off. This marks the first thumbnail of the
 * current variant set, and re-marks one whenever a variant change clears it.
 */
(function () {
  var SELECTED = 'is-initial-selected';

  function markFirst(container) {
    if (container.querySelector('.product-thumbnail.' + SELECTED)) return;
    var first = container.querySelector('.product-thumbnail.is-active') || container.querySelector('.product-thumbnail');
    if (first) first.classList.add(SELECTED);
  }

  function init() {
    var containers = document.querySelectorAll('.product-v2 .product-thumbnail-container, .product-v2 .product-thumbnails');
    containers.forEach(function (container) {
      markFirst(container);

      // A variant change clears the marker, so put it back.
      new MutationObserver(function () {
        markFirst(container);
      }).observe(container, { attributes: true, attributeFilter: ['class'], subtree: true, childList: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init(); 
  }
})();
